const typeResearchAvailables = [
  { label: 'Básica', keyword: 'BASICA' },
  { label: 'Aplicada', keyword: 'APLICADA' },
  { label: 'Desarrollo tecnológico', keyword: 'DESARROLLO TECNOLOGICO' },
];

export default typeResearchAvailables;
